import React, { Component, Fragment } from 'react';
import MetaTags from 'react-meta-tags';
import Header from '../layouts/Header';
import Footer from '../layouts/Footer';
import Breadcrumbs from '../layouts/Breadcrumbs';
// import Client from '../layouts/Client';
import Content from '../sections/service/Content';

class Service extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);
    }


    render() {
        return (
            <Fragment>
                <MetaTags>
                    <title>J.W. Oliver - Companies</title>
                    <meta
                        name="description"
                        content="#"
                    />
                </MetaTags>
                <Header />
                <Breadcrumbs breadcrumb={{ pagename: 'Companies' }} />
                <Content />
                {/* <section className="client-section">
                    <div className="container">
                        <div className="client-slider section-gap line-top">
                            <Client />
                        </div>
                    </div>
                </section> */}
                <Footer />
            </Fragment>
        );
    }
}

export default Service;